export enum LeadEmailFormStrategyStorageKeyEnum {
  /**
   * Agent strategy
   */
  agent = 'lead-email-form-strategy-agent',

  /**
   * Broker strategy
   */
  broker = 'lead-email-form-strategy-broke',

  /**
   * Property strategy
   */
  property = 'lead-email-form-strategy-property',
}
